import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Spinner from 'web/components/Spinner';
import Layout from 'web/components/Layout';
import { Helmet } from "react-helmet"; 
import OrderTabs from './OrderTabs/OrderTabs'
import { Container, Wrapper } from "./claimRaiseStyled";
import PalletsSidebar from 'web/components/PalletsSidebar';
import Breadcrumb from "web/components/Breadcrumb";
import { fetchLanguageContentNew } from 'redux/actions/language';

const ClaimRaise = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const [urlSearchParams, setURLSearchParams] = useState();

  const loaderVisible = useSelector(
    (state) => state.appReducer.loaderVisible
  );
  const urlObject = useSelector(
    (state) => state.urlParameters.resolution
  );
  
  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (languageContentNew?.Resolution_Center_Page) setPageLanguageContents(languageContentNew.Resolution_Center_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  const [expanded, expandedState] = useState();
  useEffect(() => {
    if (!localStorage.getItem('token')) {
      history.push('/sign-in')
      window.location.reload(false);
    } else {
      if(urlObject){
        setURLSearchParams({
          pageType: urlObject.pageType,
          selectedTab: urlObject.selectedTab,
        })
        expandedState(urlObject.expanded)
      }else{
        setURLSearchParams({
          pageType: 'ClaimRaise',
          selectedTab: 'CLAIM_RAISED',
        })
        expandedState('sideBar')
      }
    }
  }, []);

  let breadcrumbMapArr = [
    {
      name: pageLanguageContents?.Breadcrumb[0]?.Home,
      link: "/dashboard",
      eventType: "Link",
    },
  ];
  return (
    <>
    <Helmet title="Resolution Center: Find Answers to Your Concerns | PalletTrader" >
      <meta name="description"
    content="Resolve any issues or disputes at our resolution center. Seek assistance and find solutions for any problems encountered on our marketplace." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/resolution-center" />
      </Helmet>
      <Layout pageType="resolution" topBarViewMobile={"hide"}>
        {loaderVisible && <Spinner />}
        <Container>
          <Breadcrumb
            breadcrumbArr={breadcrumbMapArr}
            selected={pageLanguageContents?.Breadcrumb[1]?.ResolutionCenter}
            title=""
          />
          <Wrapper> <div className="pd-right-nav">           
              {expanded && <PalletsSidebar expandedPallet={expanded} />}
            </div>           
            {urlSearchParams && <OrderTabs urlSearchParams={urlSearchParams} />}
          </Wrapper>
        </Container>
      </Layout>
    </>
  );
};

export default ClaimRaise;